import get from 'lodash/get'
import toLower from 'lodash/toLower'
import trim from 'lodash/trim'
import OLLayerGroup from 'ol/layer/Group'

import * as PoziUtils from 'api/utils'

const BuildKeywords = (layerConf, olLayer = undefined, parentKeywordsArray = []) => {
  const titleid = layerConf?.titleid || olLayer?.get?.('titleid')

  if (!titleid) {
    console.log('BuildKeywords - no titleid found. Not continuing', layerConf, olLayer)
    return
  }

  // Ignore layers that will not be shown in the layer control
  if (!layerConf.showInLayerControl) {
    return
  }

  // console.debug('BuildKeywords', titleid, olLayer, parentKeywordsArray)

  // NOTE: The following block is currently commented out because we are being inefficient and currently
  //       need to call BuildKeywords more than once a layer as part of for nested layers.
  // TODO: improve efficiency and only call BuildKeywords once for a layer
  // if (layerConf?.keywords) {
  //   console.warn('BuildKeywords - layerConf already has a keywords. Not doing anything.', titleid)
  //   return
  // }

  // When we recurse into the child layers of a layer group, we want the child
  // to inherit the parent keywords (important for layertree)
  const keywordsArray = [...parentKeywordsArray]

  if (layerConf) {
    keywordsArray.push(createLayerKeywords(layerConf))
  }

  if (!olLayer) {
    console.log('BuildKeywords - no OL layer provided. Trying to retrieve from titleid...', titleid)
    olLayer = PoziUtils.getOpenLayersObjectFromTitleID(titleid)
  }

  // Try to get (more) information from the properties of a provided OL layer
  const childKeywordsArray = []
  if (olLayer) {
    const olLayerProps = olLayer.getProperties()
    keywordsArray.push(createLayerKeywords(olLayerProps))

    // Iterate over child layers.
    if (olLayer instanceof OLLayerGroup) {
      // const childLayers = PoziUtils.getAllOLLayersAndGroups(olLayer)
      const childLayers = olLayer.getLayers()

      // console.debug('BuildKeywords - childlayers', titleid, childLayers)

      childLayers.forEach(childLayer => {
        const childLayerConf = PoziUtils.getLayerFromOLLayer(childLayer)
        const childKeywords = BuildKeywords(childLayerConf, childLayer, keywordsArray)
        childKeywordsArray.push(childKeywords)
      })
    }
  }

  let keywords = [
    ...keywordsArray,
    ...childKeywordsArray
  ].join(' ')

  // Clean up keywords string by removing non-alphanumeric characters
  keywords = keywords.replace(/[^\w-]+/g, ' ').trim()

  // Store layer keywords
  if (layerConf) {
    layerConf.keywords = keywords
  }

  // console.debug('BuildKeywords final', titleid, keywords, layerConf)

  return keywords
}

// TODO: improve this code
const createLayerKeywords = (layerConf) => {
  return toLower(
    trim(
      get(layerConf, 'title', '') +
      ' ' +
      get(layerConf, 'group', '') +
      ' ' +
      get(layerConf, 'about.source', '') +
      ' ' +
      get(layerConf, 'about.organisation', '') +
      ' ' +
      get(layerConf, 'about.description', '') +
      ' ' +
      get(layerConf, 'about.date', '') +
      ' ' +
      get(layerConf, 'type', '')
    )
  )
}

export default BuildKeywords
